module.exports = __webpack_public_path__ + "img/avatar-group.af524256.png";